export default function add({mapData}) {
  return { ok: true, mapData};
}

